import { useTranslate } from "@similarweb/i18n-provider";
import { Keywords, Website } from "@similarweb/icons";
import { Button } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import {
    MONITOR_LANDINGS_TEXT,
    MONITOR_LANDINGS_TITLE,
    TRACK_KEYWORDS_TEXT,
    TRACK_KEYWORDS_TITLE,
} from "app/pages/activation/components/HomeWithData/Alerts/texts";
import { alertsDataAutomation } from "app/pages/activation/components/HomeWithData/dataAutomationKeys";
import { CREATE_PROJECT } from "app/pages/activation/components/HomeWithData/texts";
import { activationTracking } from "app/pages/activation/services/tracking";

import * as SC from "./styles";

type EmptyItemSchema = {
    type: "keywords" | "website";
    onClickCreateProject: () => void;
};

export const NoProjectItem = ({ type, onClickCreateProject }: EmptyItemSchema) => {
    const { translate } = useTranslate();
    const track = activationTracking.homePageWithData;

    const onCreateProject = () => {
        onClickCreateProject();
        track.trackCreateProjectFromAlerts();
    };

    const content = {
        keywords: {
            icon: <Keywords size="xs" />,
            title: translate(TRACK_KEYWORDS_TITLE),
            text: translate(TRACK_KEYWORDS_TEXT),
        },
        website: {
            icon: <Website size="xs" />,
            title: translate(MONITOR_LANDINGS_TITLE),
            text: translate(MONITOR_LANDINGS_TEXT),
        },
    };

    const { icon, title, text } = content[type];

    return (
        <SC.Container data-automation={alertsDataAutomation.noProjectsItem}>
            <SC.IconContainer>{icon}</SC.IconContainer>

            <SC.ContentContainer data-automation={alertsDataAutomation.noProjectsContent}>
                <SC.Title fontVariant="captionTitle">{title}</SC.Title>

                <SC.Content>
                    <Text fontVariant="listItem3">{text}</Text>
                </SC.Content>
            </SC.ContentContainer>

            <Flex alignItems="center">
                <Button
                    type="flat"
                    onClick={onCreateProject}
                    dataAutomation={alertsDataAutomation.noProjectsCreateBtn}
                >
                    {translate(CREATE_PROJECT)}
                </Button>
            </Flex>
        </SC.Container>
    );
};
